import {unix} from 'dayjs';
import {valueAsNumber} from 'schemaDefinition/functions/valueAsNumber';

export const valueAsYear = (value: unknown): number | undefined => {
  const numValue = valueAsNumber(value);
  return numValue === undefined
    ? undefined
    : Math.abs(numValue) < 3000
      ? numValue
      : unix(numValue).year();
};
